import type { Notifications } from '../types';

/**
 * Get the unread count for inbox badges. When the new chat UI is enabled this
 * includes both personal and company inbox unreads.
 * @param notifications The notifications object.
 * @param newChatUI2025Enabled The `new_chat_ui_2025` feature flag is enabled.
 */
export function getInboxUnreadCount(
    notifications: Notifications,
    newChatUI2025Enabled: boolean,
): number {
    const personalCount = notifications.personalInbox.count;
    if (!newChatUI2025Enabled) {
        return personalCount;
    }
    const companyCount = notifications.companyInboxes.reduce(
        (total, inbox) => total + inbox.count,
        0,
    );
    return personalCount + companyCount;
}
